import React from 'react';
import { useSelector, useDispatch } from 'react-redux'

// Redux slices
import { closeModal } from '../../appSlice'

// SemanticUI components
import { Container, Modal, Header, Segment, List, ListItem, ListIcon, ListContent } from 'semantic-ui-react';



/**
 * 
 * @returns 
 */
const Max2ModalAbout = () => {
    // global State
    const dispatch = useDispatch();
    const open      = useSelector((state) => state.app.modal.about.open);
    const version   = useSelector((state) => state.app.version);

    // check if modal is active
    if (!open) {
        return <></>
    };
  
    return (
        <Modal closeIcon dimmer="blurring" open={open} size="small" onClose={() => dispatch(closeModal('about'))}>
            <Modal.Header>Über MAX<sup>2</sup></Modal.Header>
            <Modal.Content scrolling>
                <Container textAlign='center' style={{color: '#ccc'}}>
                    Version: {version}<br /><br />&copy;2025 <strong>W&S Epic</strong> GmbH
                </Container>
                <Segment>
                    <Container textAlign='center'>
                        <Header as='h2'>Change-Log</Header>
                    </Container>
                    <Container style={{maxHeight: '500px', overflow: 'auto', marginTop: '25px'}}>
                        <Header as='h4' style={{borderBottom: '1px solid silver'}}>What's coming up in next major version</Header>
                        <List>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'green'}} />
                                <ListContent>
                                    Speichern von Allotment-Manipulationen im Hotelobjekt
                                </ListContent>
                            </ListItem>
                        </List>
                        <Header as='h4' style={{borderBottom: '1px solid silver'}}>Version: 25.0929.002</Header>
                        <List>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'green'}} />
                                <ListContent>
                                    In der Zielgebietsliste im Suchfilter im Dashboard sind nun Tastatur-Eingaben möglich 
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'orange'}} />
                                <ListContent>
                                    Historie in Benutzerdetails neu angeordnet
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='bug' style={{color: 'orange'}} />
                                <ListContent>
                                Darstellungsproblem beim Scrollen in der Sidebar im Hotelobjekt behoben        
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='bug' style={{color: 'red'}} />
                                <ListContent>
                                    Darstellungskorrektur im Transfer-Bereich im Hotelobjekt
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='bug' style={{color: 'red'}} />
                                <ListContent>
                                    beim Erweitern der Ergebnisliste der Systemdaten in den Einstellungen bleibt der Filter erhalten
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='bug' style={{color: 'red'}} />
                                <ListContent>
                                    Problem beim Öffnen der Druckansicht im Hotelobjekt behoben
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='bug' style={{color: 'red'}} />
                                <ListContent>
                                    Darstellungsproblem in der Menüzeile behoben
                                </ListContent>
                            </ListItem>
                            
                        </List>
                        <Header as='h4' style={{borderBottom: '1px solid silver'}}>Version: 25.0929.001</Header>
                        <List>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'green'}} />
                                <ListContent>
                                    Speichern von Verträgen
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'green'}} />
                                <ListContent>
                                    Neuanlage von Verträgen
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'green'}} />
                                <ListContent>
                                    Kopieren von Verträgen
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'green'}} />
                                <ListContent>
                                    Speichern von Hotelobjekten
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'green'}} />
                                <ListContent>
                                    Neuanlage von Hotelobjekten
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'green'}} />
                                <ListContent>
                                    Kopieren von Hotelobjekten
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'green'}} />
                                <ListContent>
                                    Teilkontingente in Vertragskomponente hinzugefügt
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'green'}} />
                                <ListContent>
                                    Teilkontingente in Allotments-Sektion im Hotelobjekt hinzugefügt
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'green'}} />
                                <ListContent>
                                    Historie im Hotelobjekt hinzugefügt
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'green'}} />
                                <ListContent>
                                    Neuanlage von Systemdaten
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'green'}} />
                                <ListContent>
                                    Neuanlage von Benutzern
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='bug' style={{color: 'orange'}} />
                                <ListContent>
                                    kleinere Darstellungskorrekturen
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='bug' style={{color: 'red'}} />
                                <ListContent>
                                    Fehlerkorrekturen
                                </ListContent>
                            </ListItem>
                        </List>
                        <Header as='h4' style={{borderBottom: '1px solid silver'}}>Version: 25.0812.001</Header>
                        <List>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'green'}} />
                                <ListContent>
                                    Userbezogener Filter für Hotelcodes in Suche berücksichtigt
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'green'}} />
                                <ListContent>
                                    Aktionen (PDF-Versand, Freigabe) in Vertragskomponente hinzugefügt
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'green'}} />
                                <ListContent>
                                    PDF-Erzeugung in Vertragskomponente hinzugefügt
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'green'}} />
                                <ListContent>
                                    EDF-Erzeugung in Vertragskomponente hinzugefügt
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'orange'}} />
                                <ListContent>
                                    Sektionen Specials/Vertragsspecials in Vertragskomponente überarbeitet
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'green'}} />
                                <ListContent>
                                    ReadOnly-Ansicht für weitere Sektionen in Vertragskomponente hinzugefügt
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'green'}} />
                                <ListContent>
                                    Sektion Bemerkungen in Vertragskomponente vervollständigt
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'green'}} />
                                <ListContent>
                                    ReadOnly-Ansicht für Sektion Aufenthalte/Anreisen/StopSale in Vertragskomponente hinzugefügt
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'green'}} />
                                <ListContent>
                                    ReadOnly-Ansicht für Sektion Saison/Zimmer/Verpflegungen in Vertragskomponente hinzugefügt
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='certificate' style={{color: 'green'}} />
                                <ListContent>
                                    Change-Log zu 'über'-Dialog hinzugefügt
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='bug' style={{color: 'orange'}} />
                                <ListContent>
                                    kleinere Darstellungskorrekturen
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='bug' style={{color: 'red'}} />
                                <ListContent>
                                    Fehler beim Öffnen eines Vertrages aus dem Objekt heraus behoben.
                                </ListContent>
                            </ListItem>
                            <ListItem>
                                <ListIcon name='bug' style={{color: 'red'}} />
                                <ListContent>
                                    Fehlerkorrekturen
                                </ListContent>
                            </ListItem>
                        </List>
                    </Container>
                </Segment>
            </Modal.Content>
        </Modal>
    )
}

export default Max2ModalAbout;